export default function ContactBar() {
  return (
    <div className="sa-contact-bar">
      <div className="sa-container">

        {/* Landline — text left, phone icon right */}
        <div className="sa-contact-box">
          <div className="sa-contact-box-text">
            <h3>Landline</h3>
            <p>020-25460262</p>
          </div>
          <div className="sa-contact-box-icon">
            <i className="fa fa-phone" aria-hidden="true" />
          </div>
        </div>

        {/* Mobile */}
        <div className="sa-contact-box">
          <div className="sa-contact-box-text">
            <h3>Mobile</h3>
            <p>9511840674</p>
          </div>
          <div className="sa-contact-box-icon">
            <i className="fa fa-mobile" aria-hidden="true" />
          </div>
        </div>

        {/* Office Hours */}
        <div className="sa-contact-box">
          <div className="sa-contact-box-text">
            <h3>Office Hours</h3>
            <p>9:00am – 8:00pm</p>
          </div>
          <div className="sa-contact-box-icon">
            <i className="fa fa-calendar" aria-hidden="true" />
          </div>
        </div>

      </div>
    </div>
  );
}
